import { requestBuilder } from '../../http/RequestBuilder';

interface SendJointAccountHolderInviteBody {
    fromUserId: string;
    toEmail: string;
    bankAccountId: string;
}

const useSendJointAccountHolderInvite =
    requestBuilder.mutation<SendJointAccountHolderInviteBody>({
        endpoint: '/api/bank-accounts/joint-invite',
        method: 'POST',
    });

export default useSendJointAccountHolderInvite;
